export const INIT_FORM_STATE = 'INIT_FORM_STATE';
export const TOGGLE_CATEGORY_TOOLBOX = 'TOGGLE_CATEGORY_TOOLBOX';
export const ON_CATEGORY_FILTER_CHANGE = 'ON_CATEGORY_FILTER_CHANGE';
export const ON_CATEGORIES_BENCHMARKS_CHANGE =
  'ON_CATEGORIES_BENCHMARKS_CHANGE';
export const TOGGLE_POTENTIAL_SAVINGS = 'TOGGLE_POTENTIAL_SAVINGS';
export const SWITCH_CATEGORIES_ORDER = 'SWITCH_CATEGORIES_ORDER';

export const initFormState = formState => ({
  type: INIT_FORM_STATE,
  payload: formState
});

export const toggleCategoryToolBox = category => ({
  type: TOGGLE_CATEGORY_TOOLBOX,
  payload: category
});

export const onCategoryFilterChange = (category, newFilter, filterIdx) => ({
  type: ON_CATEGORY_FILTER_CHANGE,
  payload: { category, newFilter, filterIdx }
});

export const onCategoriesBenchmarksChange = benchmarks => ({
  type: ON_CATEGORIES_BENCHMARKS_CHANGE,
  payload: benchmarks
});

export const togglePotentialSavings = isChecked => ({
  type: TOGGLE_POTENTIAL_SAVINGS,
  payload: isChecked
});

export const switchCategoriesOrder = (order1, order2) => ({
  type: SWITCH_CATEGORIES_ORDER,
  payload: { order1, order2 }
});
